export var FETCH_BETRADAR_STREAM = 'FETCH_BETRADAR_STREAM';
export var SUCCESS_FETCH_BETRADAR_STREAM = 'SUCCESS_FETCH_BETRADAR_STREAM';
export var FAILURE_FETCH_BETRADAR_STREAM = 'FAILURE_FETCH_BETRADAR_STREAM';
export var TOGGLE_STREAM = 'TOGGLE_STREAM';
export var RESET_BETRADAR = 'RESET_BETRADAR';



// WEBPACK FOOTER //
// ./src/actions/betradar.js